import * as API from '../api'

export const FETCHING_MEASURES = 'FETCHING_MEASURES'
export const FETCH_MEASURES = 'FETCH_MEASURES'
export const FETCH_MEASURES_ERROR = 'FETCH_MEASURES_ERROR'

export const fetchMeasures = () => {
  return dispatch => {
    dispatch({
      type: FETCHING_MEASURES,
      value: true
    })

    return API.measures.getMeasures().then(response => {
      const { data = {} } = response

      dispatch({
        type: FETCH_MEASURES,
        items: data.items
      })
    })
    .catch(error => {
      dispatch({
        type: FETCH_MEASURES_ERROR
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/measure.js